
div
  h3
    |Demographie
    |
    small(v-if='averageAge') Ø-Alter {{averageAge}}
  chart(:type='type' :params='params||{}' :options='options' :benchmark-options='benchmarkOptions' :benchmarkOpen='benchmarkOpen' :benchmarkEnabled='benchmarkEnabled' :public='public')
